
import { supabase } from "@/integrations/supabase/client";
import { SchoolUserData } from "@/types/auth";

export const checkAdminStatus = async (email: string) => {
  try {
    console.log('Checking admin status for:', email);
    
    // Directly query the admin_users table with the new RLS policy
    const { data: adminData, error } = await supabase
      .from('admin_users')
      .select('*')
      .eq('email', email)
      .maybeSingle();

    if (error) {
      console.error('Error checking admin status:', error);
      return false;
    }

    console.log('Admin status check result:', !!adminData);
    return !!adminData;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};

export const checkSchoolUserStatus = async (email: string) => {
  try {
    const { data: schoolUser, error } = await supabase
      .from('school_users')
      .select('*')
      .eq('email', email)
      .maybeSingle();

    if (error) {
      console.error('Error checking school user status:', error);
      return null;
    }

    return schoolUser;
  } catch (error) {
    console.error('Error checking school user status:', error);
    return null;
  }
};

export const createSchoolUser = async (email: string, userData: SchoolUserData) => {
  try {
    const { error } = await supabase
      .from('school_users')
      .insert([
        {
          email,
          mobile_number: userData.mobile_number,
          school_id: userData.school_id,
          role: userData.role || 'staff',
          approved: false, // New users start as unapproved
        }
      ]);

    if (error) throw error;
  } catch (error) {
    console.error('Error creating school user:', error);
    throw error;
  }
};
